import React, { useContext, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Card, Form } from 'react-bootstrap';

import { Ctx } from 'components/CtxFormFields/CtxInputs';
import RenderFormItem from 'components/CtxFormFields/FormFieldCtx';
import useErrorState, { translateError } from 'utils/hooks/useErrorState';

import { adyenFields, adyenDefault } from './formShape';

function Adyen() {
  const { level } = useParams();
  const formContext = useContext(Ctx);
  const { loading, integrationState, setEnabledSave } = formContext.values;
  const values = useMemo(
    () => ({ ...adyenDefault, ...integrationState }),
    [adyenDefault, integrationState],
  );

  const { errors, hasErrors } = useErrorState(values, adyenFields);
  const onChange = (key, value) => {
    formContext.onChange({ [key]: value });
  };

  useEffect(() => {
    setEnabledSave(!hasErrors);
  }, [errors]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="d-flex flex-column flex-fill">
      <Ctx.Provider
        value={useMemo(() => ({ values, onChange }), [values, onChange])}
      >
        {level === 'Pos' ? (
          <Card className="flex-fill my-3">
            <Card.Header>Adyen Credentials</Card.Header>
            <Card.Body className="d-flex">
              <Form className="d-flex flex-column flex-fill">
                {Object.values(adyenFields).map(({ validate, ...rest }) => (
                  <RenderFormItem
                    key={rest.id}
                    size="md"
                    name={rest.id}
                    error={translateError(errors[rest.id])}
                    {...rest}
                  />
                ))}
              </Form>
            </Card.Body>
          </Card>
        ) : (
          <Alert variant="warning">
            Adyen needs Device Port and Device IP to be configured. These are
            specific for each POS. Go to Pos Level and finish the configuration.
          </Alert>
        )}
      </Ctx.Provider>
    </div>
  );
}

export default Adyen;
